module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p11-ceef63cd250b904686afef52ee53445f.png";